import { render, staticRenderFns } from "./Deposito.vue?vue&type=template&id=1a12d65b&"
import script from "./Deposito.vue?vue&type=script&lang=js&"
export * from "./Deposito.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports